import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import UiContext from "../../store/ui-context";
import AppContext from "../../store/app-context";
import useAPIRequest from "../../custom_hooks/simple/useAPIRequest";
import { dummyListKota } from "./dummy-data";
import LoginDialog from "../../dialogs/LoginDialog";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/auth-slice";
import { confirmDialog } from "primereact/confirmdialog";
import EditProfileDialog from "../../dialogs/EditProfileDialog";

const logoPath = process.env.REACT_APP_MY_URL + "/logo128.png";

const DefaultHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedId = useSelector((state) => state.auth.loggedIn);
  const uiContext = useContext(UiContext);
  const appContext = useContext(AppContext);
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showEditProfilDialog, setShowEditProfilDialog] = useState(false);

  const [showLocationDropdown, setShowLocationDropdown] = useState(false);

  // const [listKota, setListKota] = useState([]);
  const location = useLocation();

  // use effect section
  useEffect(() => {
    fetchListKota();
  }, []);

  useEffect(() => {
    const pathname = location.pathname;
    switch (pathname) {
      case "/":
        setShowLocationDropdown(false);
        break;
      case "/list-produk":
        setShowLocationDropdown(false);
        break;
      case "/list-kategori":
        setShowLocationDropdown(false);
        break;
      default:
        setShowLocationDropdown(true);
        break;
    }
  }, [location.pathname]);

  const fetchListKota = async () => {
    return requestGet({
      fullUrl: `/api/masterdata/kota/data`,
      params: {
        page: 1,
        take: 100,
        filter: "",
        order: "nama",
        order_method: "ASC",
      },
      onSuccess: ({ pagination, message, data }) => {
        appContext.setListKota(data);
        if (data.length > 0) {
          appContext.setSelectedKota(data[0]);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // ui handling section

  const handleClickLogin = () => {
    setShowLoginDialog(true);
  };

  const handleOnClickProfile = () => {
    setShowEditProfilDialog(true);
  };

  const handleClickLogout = () => {
    const accept = async () => {
      dispatch(logout());

      if (location.pathname.includes("/edit-produk/")) {
        navigate(-1);
      }

      uiContext.showSuccessMsg("Success", "Logout berhasil");
    };

    const reject = () => {};

    confirmDialog({
      message: `Logout dari aplikasi?`,
      header: "Konfirmasi ",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptLabel: "Konfirmasi",
      rejectLabel: "Tidak",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  return (
    <div className="row-between-center w-full bg-white px-3 md:px-5 py-3 border-slate-200 border border-l-0 border-r-0 border-t-0 shadow-sm sticky top-0 z-50">
      <LoginDialog
        visible={showLoginDialog}
        onHide={() => setShowLoginDialog(false)}
      />

      <EditProfileDialog
        visible={showEditProfilDialog}
        onHide={() => setShowEditProfilDialog(false)}
      />

      <Link
        to="/"
        className="row-start-center text-slate-700 font-semibold text-lg gap-2"
      >
        <img src={logoPath} className="w-[2.2rem]" />
        <span className="leading-none">BB-Menu</span>
      </Link>
      <div className="row-start-center gap-2">
        {!loggedId && (
          <Button
            outlined
            className="!p-0 !px-3 min-w-[3rem] max-h-[2.2rem] text-slate-500 border-slate-300"
            label="Login"
            onClick={handleClickLogin}
          />
        )}
        {loggedId && (
          <Button
            outlined
            className="!p-0 !px-3 min-w-[3rem] max-h-[2.2rem] text-white border-red-300 bg-red-400"
            label="Logout"
            severity="danger"
            onClick={handleClickLogout}
          />
        )}
        {/* {!isOnEditingPage && (
          <Button
            outlined
            icon={addMode ? "pi pi-plus" : "pi pi-pencil"}
            className="!p-0 !px-3 max-h-[2.2rem] text-slate-500 border-slate-300"
            label={addMode ? "Tambah" : "Edit"}
            onClick={handleClickTambahEdit}
          />
        )} */}
        {showLocationDropdown && (
          <Dropdown
            className="border-slate-300"
            value={appContext.selectedKota}
            onChange={(e) => appContext.setSelectedKota(e.value)}
            options={appContext.listKota}
            optionLabel="nama"
            placeholder="Pilih Kota"
            checkmark={true}
            highlightOnSelect={false}
            pt={{
              input: { className: "text-sm text-slate-500 font-semibold" },
            }}
          />
        )}

        {loggedId && (
          <Button
            icon="pi pi-user"
            className="!p-0 !px-1 max-w-[2.1rem] max-h-[2.1rem] bg-slate-400 border-slate-400"
            rounded
            onClick={() => handleOnClickProfile()}
          />
        )}
      </div>
    </div>
  );
};

export default DefaultHeader;
